/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Averaged move over `short_window_sessions` trading sessions.
 */
export type DailyNavDeliverySecondaryWindow = {
  /**
   * The session the window measures from -- a real trading session on the firm's calendar, never weekday arithmetic. Null on the since-last-valuation window when the company has no prior valuation.
   */
  prior_date: string | null;
  /**
   * The arithmetic mean of the contributors' own percent changes, as a signed fraction. Null when nothing contributed.
   */
  average_pct: string | null;
  /**
   * The threshold actually applied, as a fraction: the company override when there is one, otherwise the firm default. Null when neither is set, in which case nothing can breach.
   */
  threshold: string | null;
  /**
   * Where `threshold` came from: `company` (an override), `firm` (the inherited default), or `none`.
   */
  threshold_source: DailyNavDeliverySecondaryWindow.threshold_source;
  /**
   * The firm default, carried even when an override won. `threshold` is already the effective value, so it alone cannot say what an override departed from.
   */
  firm_threshold: string | null;
  /**
   * True when abs(average_pct) is over `threshold`. Absolute: a move far below the band is as much a reason to look as one far above.
   */
  exceeded: boolean;
  /**
   * The providers actually inside `average_pct`. Load-bearing rather than decorative: a provider can drop out of a window entirely, and without this list the average would move for a reason nothing in the payload explains.
   */
  contributing_providers: Array<string>;
  /**
   * How many providers contributed, i.e. the length of the list above.
   */
  provider_count: number;
  /**
   * The upstream revision this window's prior date was read at, in UTC. Window-level because the revision is a property of the date, not of a provider.
   */
  prior_snapshot_at: string | null;
  /**
   * Which rule produced `prior_snapshot_at`: `prior_nav_day`, `report_day`, `report_day_fallback`, or `latest`. See the provider contribution field of the same name for what each means.
   */
  prior_snapshot_source: string;
};
export namespace DailyNavDeliverySecondaryWindow {
  /**
   * Where `threshold` came from: `company` (an override), `firm` (the inherited default), or `none`.
   */
  export enum threshold_source {
    COMPANY = 'company',
    FIRM = 'firm',
    NONE = 'none',
  }
}

